// Pinned: DEV — deployed Hostinger KVM1 API + dev Firebase. Build with `-c dev`.
import { ENVIRONMENTS } from './env.config';

export const environment = ENVIRONMENTS['dev'];
